<template>
  <div>
    <ValidationObserver ref="observer">
      <UserPersonnalInfo
        :user="updatedUser"
        :readonly="readonly"
        :errormessage="errorMessage"
        validation-group="UserInfoDetails"
        @change-utilisateur="changeUserInfos"
        @close-modale="emitCloseModale"
      />
      <div
        v-if="
          !readonly &&
          userService.hasAnyProfile(updatedUser, [
            PROFIL_UTILISATEUR.ENSEIGNANT,
            PROFIL_UTILISATEUR.REFERENT,
          ])
        "
      >
        <br /><br />
        <CheckboxWithValidation
          v-model="acceptNameVisibilityOnProtectedListing"
          vid="acceptNameVisibilityOnMap"
        >
          {{ $t("registerPage.accept-name-visibility-on-map") }}
        </CheckboxWithValidation>
        <br /><br />
      </div>

      <b-message v-if="errorMessage" type="is-danger">
        {{ errorMessage }}
      </b-message>
    </ValidationObserver>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import { UtilisateurDTO } from "@/model/bean/GeneratedDTOs"
import { PROFIL_UTILISATEUR } from "@/model/bean/EnumHelper"
import ValidationObserver from "@/services/validation/ValidationObserver.vue"
import { UsersService } from "@/services/rest/users/UsersService"
import UserPersonnalInfo from "@/views/commons/UserPersonnalInfo.vue"
import CheckboxWithValidation from "@/views/inputs/CheckBoxWithValidation.vue"
import { BMessage } from "buefy"

export default defineComponent({
  name: "UserInfoDetails",
  components: {
    ValidationObserver,
    UserPersonnalInfo,
    CheckboxWithValidation,
    BMessage,
  },
  props: {
    user: {
      type: Object as PropType<UtilisateurDTO>,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["user-updated", "close-modale"],
  data() {
    return {
      PROFIL_UTILISATEUR,
      updatedUser: JSON.parse(JSON.stringify(this.user)),
      userService: UsersService.INSTANCE,
      errorMessage: "",
      acceptNameVisibilityOnProtectedListing: false,
    }
  },
  watch: {
    user(): void {
      this.updatedUser = JSON.parse(JSON.stringify(this.user))
      this.acceptNameVisibilityOnProtectedListing =
        this.updatedUser.acceptNameVisibilityOnProtectedListing
    },
  },
  methods: {
    // Used by ProfileModale on save
    async submitProfile(): Promise<string> {
      const observerComponent = this.$refs["observer"]
      //@ts-ignore
      const validationResult = await observerComponent.validateWithInfo()

      const errors = Object.values(validationResult.errors).flat()
      if (errors.length !== 0) {
        this.errorMessage = this.$t("profilePage.missing-fields").toString()
        return this.errorMessage
      }

      this.errorMessage = ""
      // Updates the users personnal information
      if (this.updatedUser) {
        this.updatedUser.acceptNameVisibilityOnProtectedListing =
          this.acceptNameVisibilityOnProtectedListing
        return this.userService.updateProfile(this.updatedUser).then(
          (_success) => {
            return ""
          },
          (reject) => {
            this.errorMessage = this.$t("profilePage.modification-error").toString()
            if (parseInt(reject["status"]) == 400) {
              this.errorMessage = this.$t("registerPage.email-deja-utilise").toString()
            }
            return this.errorMessage
          },
        )
      } else {
        return ""
      }
    },
    changeUserInfos(utilisateur: UtilisateurDTO): void {
      // Mettre à jour directement les propriétés pour éviter les cycles de réactivité
      Object.assign(this.updatedUser, utilisateur)
      this.$emit("user-updated", this.updatedUser)
    },
    emitCloseModale(): void {
      this.$emit("close-modale")
    },
  },
})
</script>
